import React from 'react';

function AfricaLocationPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Africa Location</h1>
      <p>Page `fhc-africa-location.html` convertie en composant React.</p>
    </div>
  );
}

export default AfricaLocationPage;
